import { render, staticRenderFns } from "./Suedtirol.vue?vue&type=template&id=d20933ec&"
import script from "./Suedtirol.vue?vue&type=script&lang=js&"
export * from "./Suedtirol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports